export const LOCAL_STORAGE_APP_CURRENCY = 'appCurrency';
export const DATE_RANGE_FACET_NAME = 'datesRange';
export const SORT_QUERY_NAME = 'sortBy';
export const TEXT_SEARCH_FACET_NAME = 'title';
export const TAGS_FOR_PREDEFINED_FACET_NAME = 'category';